
export enum ExceptionTypeEnum {
  None = 0,
  Total = 1,
  Backend = 2,
  Mobile = 4,
  NoLaunch = 8,
  Custom = 16
}

export const EXCEPTION_TYPE_OPTIONS = [
  { value: '', label: '所有' },
  { value: ExceptionTypeEnum.None, label: '无异常' },
  { value: ExceptionTypeEnum.Total, label: '总流量异常' },
  { value: ExceptionTypeEnum.Backend, label: '后台流量异常' },
  { value: ExceptionTypeEnum.Mobile, label: '移动流量异常' },
  { value: ExceptionTypeEnum.NoLaunch, label: '没启动流量过大' },
  { value: ExceptionTypeEnum.Custom, label: '自定义场景流量过大' },
];
// 告警使用
export const ALERT_EXCEPTION_TYPE_OPTIONS = [
  { value: ExceptionTypeEnum.None, label: '无异常' },
  { value: ExceptionTypeEnum.Total, label: '总流量异常' },
  { value: ExceptionTypeEnum.Backend, label: '后台流量异常' },
  { value: ExceptionTypeEnum.Mobile, label: '移动流量异常' },
  { value: ExceptionTypeEnum.NoLaunch, label: '没启动流量过大' },
  { value: ExceptionTypeEnum.Custom, label: '自定义场景流量过大' },
];

export const EXCEPTION_TYPE_SORT = ['总流量异常', '后台流量异常', '移动流量异常', '没启动流量过大', '自定义场景流量过大'];
